import { Form, Input, Modal } from 'antd';
import React from 'react';

interface ClientModalProps {
  visible: boolean;
  onCancel: () => void;
  onSave: (values: any) => void;
  form: any;
  loading?: boolean;
}

const ClientModal: React.FC<ClientModalProps> = ({
  visible,
  onCancel,
  onSave,
  form,
  loading = false,
}) => {
  return (
    <Modal
      title="Novo Cliente"
      open={visible}
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText="Salvar"
      cancelText="Cancelar"
      confirmLoading={loading}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSave}
        preserve={false}
      >
        <Form.Item
          name="name"
          label="Nome"
          rules={[{ required: true, message: 'Informe o nome do cliente' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="E-mail"
          rules={[{ required: true, type: 'email', message: 'Informe um email válido' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Telefone"
          rules={[{ required: true, message: 'Informe o telefone do cliente' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="document"
          label="Documento"
          rules={[{ required: true, message: 'Informe o documento do cliente' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="address"
          label="Endereço"
          rules={[{ required: true, message: 'Informe o endereço do cliente' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ClientModal;
